import { render, staticRenderFns } from "./background-particles.vue?vue&type=template&id=078d3973&scoped=true&"
import script from "./background-particles.vue?vue&type=script&lang=ts&"
export * from "./background-particles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d3973",
  null
  
)

export default component.exports